// updateListing.js
const updateListing = {
    create: () => 'create/offer',
    getById: (id) => `getOfferById/${id}`,
   
}
export default updateListing
